/**
 * @file createFormData.ts
 * @description
 * -----------------------------------------------------
 * Componente para crear un FormData a partir de un objeto
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-05-06
 * @author DLTCode
 * @author Mohammed Derfoufi
 * @copyright © DLTCode
 * @license Private
 * */

const createFormData = (filters: Record<string, unknown>): FormData => {
  const fd = new FormData();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      fd.append(key, value.toString());
    }
  });
  return fd;
};

export default createFormData;
